import {
  getSearchQueryFromUrl,
  getUrlWithoutSearchQuery,
} from "../Helpers/UrlHelpers";

const sortByUrlParam = "order=";

const hasSortPart = (part: string) =>
  ["order=", "pricing=", "ratings="].some((sortPrefix) =>
    part.toLowerCase().startsWith(sortPrefix.toLowerCase()),
  );

const getUrlWithoutSort = (pageUrl: string) => {
  const urlSearch = getSearchQueryFromUrl(pageUrl);
  const searchParts = urlSearch.replace("?", "").split("&");
  const nonSortParts = searchParts.filter((part) => part && !hasSortPart(part));
  const noSortSearch = nonSortParts.length ? `?${nonSortParts.join("&")}` : "";
  const noSortUrl = `${getUrlWithoutSearchQuery(pageUrl)}${noSortSearch}`;
  return noSortUrl;
};

export const getSortByValueFromUrl = (pageUrl: string) => {
  const urlSearch = getSearchQueryFromUrl(pageUrl);
  const searchParts = urlSearch.replace("?", "").split("&");

  const sortParts = searchParts.filter((part) => part && hasSortPart(part));

  let currentSortByValue = sortParts.length ? sortParts[0]?.split("=")[1] : "";

  if (currentSortByValue === "top") {
    currentSortByValue = "rating_desc";
  }
  if (currentSortByValue === "best") {
    currentSortByValue = "price_asc";
  }

  return currentSortByValue;
};

export const updateUrlSortBy = (currentUrl: string, sortValue: string) => {
  const noSortUrl = getUrlWithoutSort(currentUrl);
  const token = noSortUrl.includes("?") ? "&" : "?";

  return `${noSortUrl}${token}${sortByUrlParam}${sortValue}`;
};
